export enum GuiLight {
    FRONT="front",
    SIDE="side"
}
